<script>
import {mapActions,} from "pinia";
import {profileStore} from "@/store/profileStore";
import NewsItem from "@/components/News/NewsItem.vue";
import InfiniteLoadingLoader from "@/components/InfiniteLoadingLoader.vue";
import BaseNoResultMessage from "@/components/BaseNoResultMessage.vue";

export default {
  name: "ProfileNewsList",
  components: {
    NewsItem,
    InfiniteLoadingLoader,
    BaseNoResultMessage
  },
  data() {
    return {
      searchParams: {
        profileId: this.$route.params.id,
        page: 0,
        size: 100,
      },
      profileNewsItems: [],
      lastItems: false
    };
  },
  computed: {
    hasNews() {
      return this.profileNewsItems.length > 0;
    }
  },
  methods: {
    ...mapActions(profileStore, [
      'getProfileNewsAction'
    ]),
    infiniteHandler($state) {
      if ($state) {
        this.getNews($state);
      }
    },
    getNews($state) {
      if (!this.lastItems) {
        this.getProfileNewsAction(this.searchParams).then((resp)=> {
          if (resp.data.length > 0) {
            this.profileNewsItems = this.profileNewsItems.concat(resp.data);
            this.pageNumber += 1;
            // this.lastItems = resp.data.numberOfElements < this.searchParams.size;

            // TODO tmp fix until the get news endpoint well be refactored
            this.lastItems = true;
            if ($state) {
              $state.complete();
              $state.loaded();
            }
          }
        });
      } else {
        $state.complete();
      }
    }
  },
  beforeUnmount() {
    this.profileNewsItems = [];
  }
}
</script>

<template>
<div class="profile-news-list">
  <news-item v-for="item in profileNewsItems"
             :key="item.id"
             :item-data="item"
  />
  <infinite-loading @infinite="infiniteHandler">
    <template #spinner>
      <InfiniteLoadingLoader/>
    </template>
    <template #no-more>
      <div></div>
    </template>
    <template #no-results>
      <base-no-result-message :text="$t('profile.noNews')"/>
    </template>
  </infinite-loading>
</div>
</template>

<style lang="scss">
.profile-news-list {
  margin-top: 10px;
}
</style>